import { UserDetails } from "../types";

class FollowedUsersStorage {
  private storageKey: string;

  constructor() {
    this.storageKey = 'followed_users';
  }

  getFollowedUserIds(): string[] {
    const storedFollowedUsers = localStorage.getItem(this.storageKey);
    if (!storedFollowedUsers) {
      return [];
    }
    
    try {
      const parsedIds = JSON.parse(storedFollowedUsers);
      return Array.isArray(parsedIds) ? parsedIds : [];
    } catch (error) {
      console.error('Error parsing followed users from localStorage:', error);
      return [];
    }
  }

  isFollowing(userId: string): boolean {
    return this.getFollowedUserIds().includes(userId);
  }

  followUser(user: UserDetails): void {
    const userId = user?.id;
    if (!userId) {
      console.error('Cannot follow user without an ID');
      return;
    }

    const followedUserIds = this.getFollowedUserIds();
    
    // Don't add if already following
    if (followedUserIds.includes(userId)) {
      return;
    }
    
    const updatedIds = [...followedUserIds, userId];
    localStorage.setItem(this.storageKey, JSON.stringify(updatedIds));
  }

  unfollowUser(user: UserDetails): void {
    const userId = user?.id;
    if (!userId) {
      console.error('Cannot unfollow user without an ID');
      return;
    }

    const followedUserIds = this.getFollowedUserIds();
    const updatedIds = followedUserIds.filter(id => id !== userId);
    localStorage.setItem(this.storageKey, JSON.stringify(updatedIds));
  }

  clearStorage(): void {
    localStorage.removeItem(this.storageKey);
  }
}

export default FollowedUsersStorage; 